import { render, staticRenderFns } from "./country.vue?vue&type=template&id=5b8fad28&"
import script from "./country.vue?vue&type=script&lang=js&"
export * from "./country.vue?vue&type=script&lang=js&"
import style0 from "./country.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8fad28')) {
      api.createRecord('5b8fad28', component.options)
    } else {
      api.reload('5b8fad28', component.options)
    }
    module.hot.accept("./country.vue?vue&type=template&id=5b8fad28&", function () {
      api.rerender('5b8fad28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/country.vue"
export default component.exports